import { render, staticRenderFns } from "./MpStokRecetesiButton.vue?vue&type=template&id=4c61eae0"
import script from "./MpStokRecetesiButton.vue?vue&type=script&lang=js"
export * from "./MpStokRecetesiButton.vue?vue&type=script&lang=js"
import style0 from "./MpStokRecetesiButton.vue?vue&type=style&index=0&id=4c61eae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports